<template>
  <div class="deal-main">
    <!-- 头部信息 S -->
    <div class="header">
      <!-- <img class="logo" v-if="mainlogo" :src="mainlogo" @click="home" /> -->
      <img class="back" src="@/assets/back.png" @click="goBack" alt="back">
      <div class="choose-type choose-min">
        <label class="title" v-if="type == 1">{{ $t('currency.bb') }}</label>
        <label class="title" v-else-if="type == 2">{{ $t('currency.hy') }}</label>
        <label class="title" v-else>{{ $t('currency.jg1') }}</label>
        <span class="iconfont iconfont-d icon-xiangxiajiantoushixin"></span>
        <span class="iconfont iconfont-u icon-xiangshang"></span>
        <div class="choose-list">
          <div class="a" :class="[type==1?'active':'']" @click="chooseType(1,symbol,1)">{{ $t('currency.bb') }}</div>
          <div class="a" :class="[type==2?'active':'']" @click="chooseType(2,symbol,1)">{{ $t('currency.hy') }}</div>
          <div class="a" :class="[type==3?'active':'']" @click="chooseType(3,symbol,1)">{{ $t('currency.jg1') }}</div>
        </div>
      </div>
      <div class="choose-type choose-currency choose-min">
        <label class="title">
          {{ symbol }}
          <span class="b" style="display:none;">5x</span>
        </label>
        <span class="iconfont iconfont-d icon-xiangxiajiantoushixin"></span>
        <span class="iconfont iconfont-u icon-xiangshang"></span>
        <div class="choose-list">
          <div class="search" style="display:none;">
            <img src="/static/image/icon-search.png" width="16" height="16">
            <input type="text">
          </div>
          <div class="content">
            <div class="sc">
              <label>{{ $t('deal.sc_list')[0] }}</label>
              <label :class="[self?'active':'']" @click="selfChoose(0)">{{ $t('deal.cs') }}</label>
              <label :class="[!self?'active':'']" @click="selfChoose(1)">{{ usdt }}</label>
            </div>
            <div class="bz">
              <div class="th">
                <div class="td">{{ $t('deal.sc_list')[1] }}</div>
                <div class="td">{{ $t('deal.sc_list')[2] }}</div>
              </div>
              <div class="scoll">
                <div class="tr" v-for="(item, index) in marketList" :key="item.id">
                  <div class="td">
                    <img :src="item.is_collect==1?'/static/image/star1.png':'/static/image/star.png'" width="16" height="16" @click="collect(item.id, index)">
                    <span @click="changeCueeency(index,item.symbol,item.type)">{{ item.symbol }}</span>
                  </div>
                  <div class="td" :class="[Number(item.grow)>0?'green':'red']">{{ item.grow }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="choose-type choose-about" v-if="currencyMessage.message">
        <div>
          <img style="vertical-align: middle;" src="/static/image/about.png" width="16" height="16">
        </div>
        <div class="choose-list">
          <label class="title">{{ currencyMessage.title }}</label>
          <div class="form">
            <div class="form-group">
              <div class="form-item">
                <span class="title">{{ $t('deal.cm')[0] }}</span>
                <span class="detail">{{ currencyMessage.issue_time }}</span>
              </div>
              <div class="form-item">
                <span class="title">{{ $t('deal.cm')[1] }}</span>
                <span class="detail">{{ currencyMessage.issue_number }}</span>
              </div>
            </div>
            <!-- <div class="form-group">
              <div class="form-item">
                <span class="title">{{ $t('deal.cm')[2] }}</span>
                <span class="detail">{{ currencyMessage.amount }}</span>
              </div>
              <div class="form-item">
                <span class="title">{{ $t('deal.cm')[3] }}</span>
                <span class="detail">{{ currencyMessage.price }}</span>
              </div>
            </div> -->
            <div class="form-item">
              <span class="title">{{ $t('deal.cm')[4] }}</span>
              <span class="detail">
                <a :href="currencyMessage.weburl" target="_blank">{{ currencyMessage.weburl }}</a>
              </span>
            </div>
            <div class="form-item">
              <span class="title">{{ $t('deal.cm')[5] }}</span>
              <span class="detail">
                <a :href="currencyMessage.white_book" target="_blank">{{ currencyMessage.white_book }}</a>
              </span>
            </div>
            <div class="form-item">
              <span class="title">{{ $t('deal.cm')[6] }}</span>
              <span class="detail message">{{ currencyMessage.message }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="choose-type choose-price">
        <span>Vol </span>
        <span class="green">{{ sellAndBuy.sum }}</span>
        <span :class="[sellAndBuy.ins>0?'green':'red']" style="margin-left:16px;">{{ sellAndBuy.ins>0?'+':'' }}{{ sellAndBuy.ins }}%</span>
      </div>
      <div class="choose-type choose-about" style="line-height: initial;">
        <div class="form form-2">
            <div class="form-item">
              <span class="title">{{ $t('deal.sc_h')[0] }}</span>
              <span class="detail">{{ sellAndBuy.price }}</span>
            </div>
            <div class="form-item">
              <span class="title">{{ $t('deal.sc_h')[1] }}</span>
              <span class="detail">{{ sellAndBuy.low }}</span>
            </div>
            <div class="form-item">
              <span class="title">{{ $t('deal.sc_h')[2] }}</span>
              <span class="detail">{{ sellAndBuy.high }}</span>
            </div>
            <div class="form-item">
              <span class="title">{{ $t('deal.sc_h')[3] }}</span>
              <span class="detail">{{ sellAndBuy.sum }}</span>
            </div>
        </div>
      </div>
    </div>
    <!-- 头部信息 E -->
    <!-- 内容 S -->
    <div class="deal-content">
      <div class="left">
        <!-- left-t S -->
        <div class="left-t">
          <div class="left-box-2">
            <!-- K线图 -->
            <div class="k-line" style="width:100%;height:100%;">
              <div class="trading-view" style="width:100%;height:100%;">
                <div id="tradingview" class="ao-tv" style="width:100%;height:100%;"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- left-t E -->
        <!-- <div class="btn-box" v-show="type == 3">
          <button class="btn btn1" type="button" @click="buy($t('jgcc.mz'),1)">{{$t('jgcc.mz')}}</button>
          <button class="btn btn2" type="button" @click="buy($t('jgcc.md'),2)">{{$t('jgcc.md')}}</button>
        </div> -->
        <!-- 账户信息 -->
        <div class="account">
          <span class="aaa">{{ $t('deal.account')[0] }}: </span>
          <!-- <span class="aaa">{{ sellAndBuy.currency }}</span>
          <span class="aaa" v-if="mark === 1 || mark == null ">{{ $t('deal.dir2')[0] }}</span>
          <span class="aaa" v-else>{{ $t('deal.dir2')[1] }}</span>
          <span class="eee">{{ wallet.positions }}，</span> -->
          <span style="display:none;" class="aaa">{{ $t('deal.account')[2] }}</span>
          <span style="display:none;" class="eee">{{ wallet.positions_lock }}</span>
          <span style="display:none;" class="blue" @click="link(sellAndBuy.currency)">{{ $t('deal.account')[3] }}{{ sellAndBuy.currency }}</span>
          <span class="aaa">{{ $t('deal.account')[1] }}</span>
          <span class="eee">{{ wallet.usdt }}</span>
          <span class="aaa">{{ usdt }}</span>
          <span style="display:none;" class="aaa">{{ $t('deal.account')[2] }}</span>
          <span style="display:none;" class="eee">{{ wallet.usdt_lock }}</span>
          <!-- <span class="blue" @click="link(usdt)">{{ $t('deal.account')[3] }}{{ usdt }}</span> -->
          <span class="abcd" ></span>
        </div>
        <!-- left-b S -->
        <div class="left-b" v-if="type == 1 || type == 2">
          <div class="tab">
            <div style="display: flex;">
              <div
              class="tab-item"
              :class="[ tabListLTitleIndex === index ? 'active' : '' ]"
              v-for="(item, index) in tabListLTitle"
              :key="index"
              @click="tabl(index)"
            >{{ item }}</div>
			    <div> {{ sellAndBuy.desc }}</div>
            </div>
            <div style="margin-right: 16px;" v-if="type==2">
              <span style="font-size: 14px;cursor: pointer;" @click="path('/lt')">{{ $t('deal.pathList')[0] }}</span>
              <span style="font-size: 14px;cursor: pointer;" @click="path('/dealList')">{{ $t('deal.pathList')[1] }}</span>
            </div>
          </div>
          <div class="entrust">
            <div class="entrust-tab" style="display:none;">
              <div
                class="entrust-tab-item"
                :class="[ tabListLEntrustIndex === index ? 'active' : '' ]"
                v-for="(item, index) in tabListLEntrust"
                :key="index"
                @click="tabe(index)"
              >
                <span>{{ item }}</span>
              </div>
            </div>
            <div class="entrust-content">
              <div class="th flex">
                <div class="td">{{ index_td_l[0] }}</div>
                <div class="td">{{ index_td_l[1] }}</div>
                <div class="td">{{ index_td_l[2] }}</div>
                <div class="td">{{ index_td_l[3] }}</div>
                <div class="td">{{ $t('bbjyNew.jyze') }}</div>
                <div class="td">{{ $t('jgcc.sxf') }}</div>
                <div class="td">{{ $t('bbjyNew.jylx') }}</div>
                <div class="td">{{ index_td_l[4] }}</div>
              </div>
              <div style="overflow-y: scroll;height: 100px;">
                <div class="tr flex" v-for="(item, index) in weituoList" :key="index">
                  <div class="td">{{ item.time }}</div>
                  <div class="td">{{ item.currency }}</div>
                  <div class="td">{{ item.amount }}</div>
                  <div class="td">{{ item.price }}</div>
                  <div class="td">{{ item.total }}</div>
                  <div class="td">{{ item.fee }}</div>
                  <div class="td">{{ item.price_type | priceType}}</div>
                  <div class="td">
                    <span
                      v-if="item.status === 0"
                      class="btn"
                      @click="cancel(index, item.id)"
                    >{{ table_btn[0] }}</span>
                    <span v-else-if="item.status === 1" class="text">{{ table_txt[0] }}</span>
                    <span v-else class="text">{{ table_txt[1] }}</span>
                  </div>
                </div>
              </div>
              <ao-pagination
                :total="total"
                :display="5"
                :currentPage="1"
                :pagegroup="10"
                @pagechange="pagechange"
              ></ao-pagination>
            </div>
          </div>
        </div>
        <div class="left-b" v-else>
          <div class="tab" style="display: flex;">
            <div style="display: flex;">
              <div class="tab-item" :class="{active: footIdx == 0}" @click="footTab(0)">{{$t('jgcc.wtgd')}}</div>
              <div class="tab-item" :class="{active: footIdx == 1}" @click="footTab(1)">{{$t('jgcc.cj')}}</div>
              <div class="tab-item" :class="{active: footIdx == 2}" @click="footTab(2)">{{$t('jgcc.jj')}}</div>
            </div>
            <div style="margin-right: 16px;">
              <span style="font-size: 14px;cursor: pointer;" @click="path('/jgcc')">{{ $t('jgcc.jgjl') }}</span>
            </div>
          </div>
          <!-- 委托挂单 -->
          <div class="entrust-content" v-show="footIdx == 0">
            <div class="th flex">
              <div class="td td-3 tl">{{$t('jgcc.sl')}}</div>
              <div class="td td-3">{{$t('jgcc.jg')}}</div>
              <div class="td td-3 tr">{{$t('jgcc.sl')}}</div>
            </div>
            <div class="wtgd-box" style="overflow-x: hidden;overflow-y: scroll;height: 198px;">
              <div class="wtgd-left">
                <div class="tr flex" v-for="(item,index) in this.sellAndBuy.buy" :key="index">
                  <div class="td td-3 tl">{{item.number}}</div>
                  <div class="td td-6">{{item.price}}</div>
                  <div class="td"></div>
                </div>
              </div>
              <div class="wtgd-right">
                <div class="tr flex" v-for="(item,index) in this.sellAndBuy.buy" :key="index">
                  <div class="td td-6 tl">{{item.price}}</div>
                  <div class="td td-3">{{item.number}}</div>
                  <div class="td"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 成交 -->
          <div class="entrust-content" v-show="footIdx == 1">
            <div class="th flex">
              <div class="td td-2">{{$t('jgcc.sj')}}</div>
              <div class="td td-2">{{$t('jgcc.fx')}}</div>
              <div class="td td-2">{{$t('jgcc.jg')}}</div>
              <div class="td td-2">{{$t('jgcc.sl')}}</div>
            </div>
            <div style="overflow-x: hidden;overflow-y: scroll;height: 160px;">
              <div class="tr flex" v-for="(item,index) in dealOrderList" :key="index">
                <div class="td td-2">{{item.time}}</div>
                <div class="td td-2 mr" :class="{mc: item.class == 'sell'}">{{item.class}}</div>
                <div class="td td-2">{{item.price}}</div>
                <div class="td td-2">{{item.sum}}</div>
              </div>
            </div>
          </div>
          <!-- 简介 -->
          <div class="entrust-content" v-show="footIdx == 2">
            <div style="overflow-x: hidden;overflow-y: scroll;height: 180px;">
              <div class="cont">{{currencyMessage.message}}</div>
              <ul class="cont-ul">
                <li class="cont-li">
                  <div class="text">{{ $t('deal.cm')[0] }}</div>
                  <div class="text">{{currencyMessage.issue_time}}</div>
                </li>
                <li class="cont-li">
                  <div class="text">{{ $t('deal.cm')[1] }}</div>
                  <div class="text">{{currencyMessage.issue_number}}</div>
                </li>
                <li class="cont-li">
                  <div class="text">{{ $t('deal.cm')[5] }}</div>
                  <div class="text">{{currencyMessage.white_book}}</div>
                </li>
                <li class="cont-li">
                  <div class="text">{{ $t('deal.cm')[4] }}</div>
                  <div class="text">{{currencyMessage.weburl}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- left-b E -->
      </div>
      <div class="right">
        <div class="right-t">
          <div class="right-t-l">
            <div class="price">{{ index_td_r[0] }} {{ sellAndBuy.price }}{{ usdt }}</div>
            <div class="th flex">
                <div class="td">{{ $t('deal.index_td_r')[1] }}</div>
                <div class="td">{{ $t('deal.index_td_r')[2] }}</div>
                <div class="td">{{ $t('deal.index_td_r')[3] }}</div>
            </div>
            <div id="list" class="list" @scroll="scroll">
              <div
                class="tr flex sell-box"
                v-for="(item, index) in sellAndBuy.sell"
                :key="index"
                @click="changePrice(item.price)"
              >
                <div class="td sell ">{{ item.title }}</div>
                <div class="td">{{ ffff(item.price,4) }}</div>
                <div class="td">{{ ffff(item.number,4) }}</div>
              </div>
              <div class="line">
                <span>{{ sellAndBuy.price }}</span>
              </div>
              <div class="line-back"></div>
              <div
                class="tr flex buy-box"
                v-for="(item, index) in sellAndBuy.buy"
                :key="index+10"
                @click="changePrice(item.price)"
              >
                <div class="td buy">{{ item.title }}</div>
                <div class="td">{{ ffff(item.price,4) }}</div>
                <div class="td">{{ ffff(item.number,4) }}</div>
              </div>
            </div>
            <!-- 下单框 -->
            <div style="height:4px;background:#000;" v-show="type == 1 || type == 2"></div>
            <!-- 右边底部交易 -->
            <div class="right-b" v-show="type == 1 || type == 2">
              <div class="right-b-tab">
                <div
                  class="right-b-tab-item"
                  :class="[index === tabListLEntrustIndex ? (tabListLEntrustIndex==0?'active':'active1') : '']"
                  v-for="(item, index) in tabListLEntrust"
                  :key="index"
                  @click="tabr(index)"
                >{{ item }}{{ sellAndBuy.currency }}</div>
              </div>
              <div class="right-b-content">
                <div class="right-c-l">
                  <ao-deal-box
                    :type="type"
                    :mark="tabListLEntrustIndex==0?1:2"
                    :price="sellAndBuy.price"
                    :wallet="wallet"
                    :currency="symbol.split('/')[0]"
                    :set-price="setPrice"
                    :deal-rate="deal_rate"
                    :usdt="usdt"
                    :xianjia="xianjia"
                    @event="createOrder"
                  ></ao-deal-box>
                </div>
              </div>
            </div>
            <div class="right-b" v-show="type == 3">
              <div class="btn-box">
                <template v-if="sellAndBuy.price">
                  <button class="btn btn1" type="button" @click="buy($t('jgcc.mz'),1)">{{$t('jgcc.mz')}}</button>
                  <button class="btn btn2" type="button" @click="buy($t('jgcc.md'),2)">{{$t('jgcc.md')}}</button>
                </template>
                <template v-else>
                  <button class="btn btn1" type="button" style="background: #666">{{$t('jgcc.mz')}}</button>
                  <button class="btn btn2" type="button" style="background: #666">{{$t('jgcc.md')}}</button>
                </template>
              </div>
            </div>
            <!-- 下单框 -->
          </div>
          <div class="right-t-r" style="overflow-y: scroll;">
            <div class="price">{{ index_td_r2[0] }}</div>
            <div class="list">
              <div class="th flex">
                <div class="td">{{ index_td_r2[1] }}</div>
                <div class="td">{{ index_td_r2[2] }}</div>
                <div class="td">{{ index_td_r2[3] }}</div>
              </div>
              <div class="tr flex" v-for="(item, index) in dealOrderList" :key="index">
                <div class="td" :class="item.class">{{ item.time }}</div>
                <div class="td" :class="item.class">{{ ffff(item.price, 8) }}</div>
                <div class="td" :class="item.class">{{ ffff(item.sum, 4) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="right" v-else>
        <jgcc></jgcc>
      </div> -->
    </div>
    <!-- 内容 E -->
    <div class="mask" v-show="isMask" @click="close"></div>
    <!-- 订单确认 -->
     <div class="alert-wrap" v-show="isJgShow">
        <div class="alert-box">
            <div class="alert-head order-head">
                <div class="title">{{$t('jgcc.ddqr')}}</div>
                <div><img class="close" src="@/assets/close.png" alt="" @click="close"></div>
            </div>
            <div class="alert-tips">{{$t('jgcc.dqsj')}}</div>
            <div class="time-wrap">
                <ul class="time-box">
                    <li class="time-item" :class="{active: timeIdx == index}" v-for="(item,index) in cutTimeList" :key="item.id" @click="timeSelect(index,item)">
                        <div class="t1">{{$t('jgcc.jssj')}}</div>
                        <div class="time" v-if="item.time == 3600"><span class="num">1</span> H</div>
                        <div class="time" v-else-if="item.time == 43200"><span class="num">12</span> H</div>
                        <div class="time" v-else-if="item.time == 86400"><span class="num">1</span> Day</div>
                        <div class="time" v-else-if="item.time == 172800"><span class="num">2</span> Day</div>
                        <div class="time" v-else-if="item.time == 259200"><span class="num">3</span> Day</div>
                        <div class="time" v-else-if="item.time == 345600"><span class="num">4</span> Day</div>
                        <div class="time" v-else-if="item.time == 432000"><span class="num">5</span> Day</div>
                        <div class="time" v-else-if="item.time == 518400"><span class="num">6</span> Day</div>
                        <div class="time" v-else-if="item.time == 604800"><span class="num">7</span> Day</div>
                        <div class="time" v-else><span class="num">{{item.time}}</span> S</div>
                        <!-- <div class="time"><span class="num">{{item.time}}</span> {{$t('jgcc.miao')}}</div> -->
                        <div class="t2"><span>{{$t('jgcc.sy')}} </span>{{item.rate}}%</div>
                        <img class="icon" src="@/assets/select.png" v-show="timeIdx == index" alt="">
                    </li>
                </ul>
            </div>
            <div class="alert-tips">{{$t('jgcc.tzje')}}</div>
            <div class="input-box" v-if="lang == 'ar'">
              <div class="text" style="padding: 0 10px">USDT</div>
              <input class="input" type="number" min="0" v-model="tzmoney" :placeholder="$t('jgcc.zxtzje') + timeObj.amount_min" @keyup="keyMoney()">

            </div>
            <div class="input-box" v-else>
                <input class="input" type="number" min="0" v-model="tzmoney" :placeholder="$t('jgcc.zxtzje') + timeObj.amount_min" @keyup="keyMoney()">
                <div class="text">USDT</div>
            </div>
            <div class="ky-box">
                <div class="text"><span>{{$t('jgcc.kyye')}}</span><span v-show="isKyZcShow" class="money">{{wallet.usdt}}</span><span v-show="!isKyZcShow" class="money">******</span><img class="icon" v-show="!isKyZcShow" src="@/assets/eyes.png" @click="change" alt="" /><img class="icon" src="@/assets/eyes2.png" v-show="isKyZcShow" @click="change" alt=""></div>
                <div class="text"><span>{{$t('jgcc.sxf')}}: </span>{{rate}}%</div>
            </div>
            <div class="trade-wrap">
                <div class="trade-box">
                    <div class="text">{{$t('jgcc.jypz')}}</div>
                    <div class="text text-center">{{$t('jgcc.jyfx')}}</div>
                    <div class="text text-right">{{$t('jgcc.xj')}}</div>
                </div>
                <div class="trade-box trade-item">
                    <div class="text t1">{{symbol}}</div>
                    <div class="text t2 text-center" :class="{active: fx == 2}">{{fxText}}</div>
                    <div class="text t3 text-right">{{sellAndBuy.price | toFixed4}}</div>
                </div>
            </div>
            <div class="alert-btn-box">
                <button id="order" type="button" class="btn order" @click="order(1)">{{$t('jgcc.qrxd')}}</button>
            </div>
        </div>
    </div>
    <div class="alert-wrap" v-show="isJgTime">
        <div class="alert-box">
            <div class="alert-head">
                <div class="title">{{detailData.currency_name}}</div>
                <div><img class="btn-close" src="@/assets/close.png" alt="" @click="close"></div>
            </div>
              <!-- 结果 -->
              <div class="price-box" v-show="is_close">
                <div v-show="detailData.is_close == 1"><span>{{$t('jgcc.yk')}}</span> <span class="num" v-if="detailData.profit_loss == 0"></span><span class="num" v-else :class="{red: detailData.profit_loss < 0}">{{detailData.profit_loss}}</span> USDT</div>
                <div v-show="detailData.is_close == 0" style="color: #4bb3e8; font-size: 15px;">{{$t('jgcc.ddz')}}</div>
              </div>
              <!-- 结果 -->
            <div class="circle-box" v-show="!is_close">
                <div id="times" class="text">{{detailData.cut_time}} s</div>
                <svg class="circle" width="84" height="84">
                    <circle cx="40" cy="40" r="36" fill="transparent" stroke="#4bb3e8" stroke-width="6"></circle>
                    <circle id="circle" class="alert-sec-circle" cx="40" cy="40" r="36" fill="transparent" stroke="#232a44" stroke-width="8" transform="rotate(-90 40 40)"></circle> </svg>
            </div>
            <ul class="item-box">
                <li class="item" v-show="is_close">
                    <div>{{$t('jgcc.jsj')}}</div>
                    <div class="t1">{{detailData.close_price}}</div>
                </li>
                <li class="item" v-show="!is_close">
                    <div>{{$t('jgcc.gmj')}}</div>
                    <div class="t1">{{detailData.price}}</div>
                </li>
                <li class="item" v-show="!is_close">
                    <div>{{$t('jgcc.xj')}}</div>
                    <div class="t1">{{sellAndBuy.price | toFixed4}}</div>
                </li>
                <li class="item">
                    <div>{{$t('jgcc.fx')}}</div>
                    <div class="t2" :class="{red: detailData.type == 2}">{{detailData.type | fx}}</div>
                </li>
                <li class="item">
                    <div>{{$t('jgcc.sl')}}</div>
                    <div class="t1">{{detailData.amount}}</div>
                </li>
                <li class="item">
                    <div>{{$t('jgcc.jgsj')}}</div>
                    <div class="t1">{{detailData.cut_time}} S</div>
                </li>
                <li class="item" v-show="is_close">
                    <div>{{$t('jgcc.dqye')}}</div>
                    <div class="t1">{{detailData.hy_usdt}}</div>
                </li>
            </ul>
            <div class="alert-btn-box">
                <button type="button" class="btn close" @click="close">{{$t('jgcc.gb')}}</button>
                <button type="button" class="btn order" @click="agin">{{$t('jgcc.jxxd')}}</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import AoNav from "@/components/AoNav";
import pagination from "@/components/pagination";
import AoDealBox from "./components/AoDealBox";
import AoTv from "./components/AoTv";
import AoWidget from "./components/AoTv-widget";
import jgcc from "@/components/jgcc";
import { marke_price, number_round  } from '@/utils/index'

import { getCurrencyPriceAndIncrease, getInfo, getmarketList,addCollectCurrenct,getCurrencyMessage,new_data} from "@/api/index";
import { createOrder, getWeiTuo, orderCancel,cutTimeList,cutBuy,cutOrder} from "@/api/asset";

var TIMER = null;
var index_timer = null
let that;
export default {
  props: {
    mainType: Number
  },
  components: {
    AoNav,
    AoDealBox,
    AoPagination: pagination,
    AoTv,
    jgcc
  },
  data() {
    return {
      mainlogo: sessionStorage.getItem('web_logo'),
      marketList: [],
      usdt: "",
      k_line_txt: this.$t("deal.k_line_txt"), //["≈", "CNY", "涨幅", "最高价", "最低价", "24H量"],
      table_btn: this.$t("deal.table_btn"), //["撤单"],
      index_td_l: this.$t("deal.index_td_l"), //["时间", "交易对象", "数量", "价格", "操作"],
      index_td_r: this.$t("deal.index_td_r"), //["最新价", "方向", "价格", "数量"],
      index_td_r2: this.$t("deal.index_td_r2"), //["全站交易", "时间", "价格", "交易量"],
      table_txt: this.$t("deal.table_txt"), //["交易已完成", "已撤单"],

      currencyList: [],

      sellAndBuy: {
        currency: "", // 币种
        price: "", // 当亲价格
        cny: "", // 兑换为人民币价格
        sell: [], // 卖10挡
        buy: [], // 买10挡
        high: "", // 最高价
        low: "", // 最低价
        ins: "", // 涨幅
        sum: "" ,// 24小时成交量
        desc: "" // 简介

      },
      dealOrderList: [],

      tabListLTitleIndex: 0,
      tabListLTitle: this.$t("deal.tabListLTitle"), //["当前委托", "历史委托"],

      tabListLEntrustIndex: 0,
      tabListLEntrust: this.$t("deal.tabListLEntrust"), //["买入", "卖出"],

      wallet: {
        usdt:'',
        usdt_lock:0,
        positions:0,
        positions_lock:0,
        desc:'',
      },

      weituoList: [],
      page: 1,
      total: 0,
      widget: null,
      symbol: "",
      setPrice: "",
      deal_rate: 0,
      self: 0,
      isScroll: true,
      type: 1,
      currencyMessage: {
        title: '',
        issue_time: '',
        issue_number: '',
        weburl: '',
        white_book: '',
        message: ''
      },

      deal_dir: this.$t('deal.dir'),
      text_login: this.$t('text.login'),
      match_trade_len: 30, // 最新交易信息
      deal_len:5, // 5个五档行情
      footIdx: 0,

      timeIdx: 0,
      status: 1,//1.在持，2.历史
      type: 1,//1买涨，2买跌
      symbol: '',
      orderId: '',
      cutTimeList: [],
      orderData: [],
      detailData: {},
      timeObj: {},
      curDataLength: 10,
      tzmoney: '',//投资金额
      newprice: '0.0000',
      xianjia: '',//现价
      fx: this.$t('jgcc.fx'),
      fxText: '',//方向文本
      rate: '',//手续费
      useBalance: '',//可用余额
      orderId: '',
      timer: null,
      timerTimes: null,
      timerOrder: null,
      klineTimer: null,
      orderTimes: null,
      is_close: false,
      isJgShow: false,
      isJgTime: false,//交割倒计时
      isScroll: false,//是否滚动到底部
      close_time_set_stamp: '',
      isMask: false,
      klineData: '',
      count: 1,
      isKyZcShow: false,
      lang: 'en',
      bzType: 1
    };
  },
  width:{
    mainType(a,b){
      // console.log(a,b)
    }
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.lang = localStorage.getItem('lang') || 'en';
    let kyZcShow = localStorage.getItem('kyZcShow');
    if(kyZcShow == null || kyZcShow == 'false'){
        localStorage.setItem('kyZcShow',false);
        this.isKyZcShow = false
    }else{
        localStorage.setItem('kyZcShow',true);
        this.isKyZcShow = true
    }
  },
  mounted() {
    this.usdt = this.$store.getters.usdt;
    this.symbol = this.$route.query.symbol || '';
    this.type = this.mainType;
    console.log(this.type)
    this.self = 0;
    if(this.symbol){
      this.sellAndBuy.currency = this.symbol.split('/')[0]
    }

    localStorage.setItem("type2", "1min");
    // 获取行情信息

    this.getmarketList({id:this.self?0:1,type: 1}, ()=>{
      if(!this.symbol) this.symbol = this.marketList[0].symbol
      this.sellAndBuy.currency = this.symbol.split('/')[0];
      for(var i =0;i< (this.marketList).length ;i++){
          if(this.sellAndBuy.currency ==  this.marketList[i].symbol.split('/')[0]){
             this.sellAndBuy.desc = this.marketList[i].desc
             break;
          }
      }
      //获取现价
      this.getCurPrice();
      // 获取用户信息
      this.getInfo();
      // 获取委托信息
      this.createTimer();
      this.getCurrencyMessage()
      this.initWebSocket();
      this.createWidget(true);
      this.getWeiTuo();
    })
    // 数据推算
    // this.socket();
    this.getNewData();
    this.$list = $('#list')
    this.$line = this.$list.find('.line')
    window.addEventListener('scroll', this.scroll, true);
    index_timer = init_polling(()=>{
      // this.getmarketList({id:this.self?0:1});
      // this.getNewData();
    })
  },
  destroyed() {
    index_timer&&clearInterval(index_timer)
    TIMER && clearInterval(TIMER);
    this.widget.remove();
    clearInterval(this.timerTimes);
    clearInterval(this.klineTimer);
    this.timerTimes = null;
    this.klineTimer = null;
    clearInterval(this.orderTimes);
    this.orderTimes = null;
    this.websock.close(); //离开路由之后断开websocket连接
    localStorage.removeItem('new_price')
  },
  methods: {
    getCurPrice(){
      let params = {
          id: 1,
          symbol: this.symbol,
          type: 1
      }
      getmarketList(params).then(res=>{
        this.xianjia =  res[0].new_price || this.sellAndBuy.price;
      })
    },
    change(){
        this.isKyZcShow = !this.isKyZcShow;
        localStorage.setItem('kyZcShow',this.isKyZcShow)
    },
    initWebSocket(){ //初始化weosocket
        const wsuri = window.GLOBAL.webSocket;
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
    },
    websocketonopen(){ //连接建立之后执行send方法发送数据
        this.klineTimer = setInterval(()=>{
            var msg = {"action": "kline",'currency':this.sellAndBuy.currency,"content": ''};
            this.websocketsend(JSON.stringify(msg));
        },3000)
    },
    websocketonerror(){//连接建立失败重连
        this.initWebSocket();
    },
    websocketonmessage(e){ //数据接收
        let currency = this.sellAndBuy.currency.toLowerCase();
        if(JSON.parse(e.data).action == "marketprice"){
          let msg = JSON.parse(e.data).content;
          let daymarket = msg[currency];
          let keyArr = [];
            for(var x in this.currencyList){
              for(var y in this.marketList){
                x = this.bzType == 1 ? x.toLowerCase() : x;
                if(!msg[x]) return;
                if(msg[x].symbol == this.marketList[y].symbol){
                  this.marketList[y]['new_price'] = msg[x].now_price;
                  this.marketList[y]['grow'] = msg[x].change;
                  keyArr.push(this.marketList[y]);
                  break;
                }
              }
            }
            this.marketList = keyArr;
          if (daymarket) {
            this.setValue(daymarket);
          }
        }else if(JSON.parse(e.data).action == "kline"){
          this.klineData = '';
          let msg = JSON.parse(e.data).content;
          this.klineData = msg.kline;
          localStorage.setItem('klineData',JSON.stringify(msg.kline))
          let market_depth = msg.market_depth;
          let match_trade = msg.match_trade;
          if (market_depth) {
            this.setDeal(market_depth);
          }
          if (match_trade) {
            var data = match_trade.data;
            data.forEach(obj => {
              if (this.dealOrderList.length === this.match_trade_len) {
                this.dealOrderList.pop();
              }
              this.dealOrderList.unshift({
                class: obj.direction,
                time: this.timestampToTime(obj.ts),
                price: number_round(obj.price),
                sum: number_round(obj.amount)
              });
            });
          }
        }
    },
    websocketsend(Data){//数据发送
        this.websock.send(Data);
    },
    websocketclose(e){  //关闭
        console.log('断开连接',e);
    },
    goBack(){
      localStorage.removeItem('type');
      this.$router.push('/index');
    },
    getCurrencyMessage() {
      getCurrencyMessage({currency:this.sellAndBuy.currency}).then(res => {
        if(res){
          this.currencyMessage = res
        }else{
           this.currencyMessage = {
            title: '',
            issue_time: '',
            issue_number: '',
            weburl: '',
            white_book: '',
            message: ''
          }
        }
      })
    },
    footTab(idx){
      this.footIdx = idx;
      if(idx == 2){
          this.getCurrencyMessage();
      }
    },
    link(a) {
      localStorage.setItem('transfer-type',this.type)
      localStorage.setItem('transfer-currency',a)
      this.$router.push({ path: '/transfer' })
    },
    // 币币和合约切换，重新抓取行情
    chooseType(t,symbol,bzType){
      if(this.type==t)return;
      localStorage.setItem('type',t);
      this.getWeiTuo()
      this.type = t;
      this.getCurrencyMessage();
      this.getmarketList({id:1,type: 1},() => {
        // 获取委托信息
        var index = this.marketList.findIndex(o=>o.symbol == this.symbol)
        this.changeCueeency(index,symbol,bzType);
      })
    },
    scrollTop() {
      setTimeout(()=>{
        if(this.$list.height() < 290){
          this.$list.scrollTop((290 - this.$list.height())/2);
        }else{
          this.$list.css({'overflow':'hidden'});
        }
      },0)
    },
    selfChoose(id) {
      this.marketList = [];
      this.self = !this.self
      this.getmarketList({id:id,type: 1});
    },
    collect(id, index) {
      if(this.checkToken())return
      addCollectCurrenct({id}).then(res => {
        this.marketList[index].is_collect = !this.marketList[index].is_collect
        if(this.self){
          this.marketList.splice(index,1)
        }
      })
    },
    getmarketList(data, callback) {
      getmarketList(data).then(res=>{
        this.marketList = res;
        this.currencyList = [];
        for (var curr in res){
          this.currencyList[this.marketList[curr].currency] = [this.marketList[curr].change,this.marketList[curr].symbol];
          // this.currencyList[this.marketList[curr].currency_name.toLowerCase()] = [this.marketList[curr].symbol];
        }
        if(!window.GLOBAL.is_sw_market&&this.symbol){
          var item = res.find(o=>o.symbol==this.symbol)
          item && this.setValue(item)
        }
        callback&&callback()
      })
    },
    getMarketInfo(symbol){
      return this.marketList.find(o=>o.symbol==symbol)
    },
    home() {
      this.$router.push({ path: '/index' })
    },
    scroll(event) {
      return
       let scrollTop = document.documentElement.scrollTop ||
       document.body.scrollTop ||
       this.$list.scrollTop();
       if(scrollTop>257){
          $('.line-back').show();
          this.$line.css({
            position: "absolute",
            width: '300px',
            top: scrollTop+'px',
            left: 0
         })
       }
       if(scrollTop<257&&scrollTop>138){
         $('.line-back').hide();
          this.$line.css({
            position: "inherit",
            width: '300px',
            top: 'auto',
            bottom: 'auto',
            left: 0
         })
       }
       if(scrollTop<138){
         $('.line-back').show();
          this.$line.css({
            position: "absolute",
            width: '300px',
            bottom: (0-scrollTop)+'px',
            left: 0
         })
       }
    },
    createWidget(b=false) {
      this.$nextTick(() => {
        const container_id = "tradingview";
        const width = "100%";
        const height = 535;
        const priceScale = localStorage.getItem("type2");
        const symbol = this.symbol;
        var widget = (this.widget = new AoWidget({
          container_id,
          width,
          height,
          priceScale,
          symbol,
          type: this.type
        }));
        widget.create().ready();
        widget.prevData = null;
        this.widget.connect()
      });
    },
    createTimer() {
      this.getInfo();
      // TIMER && clearInterval(TIMER);
      // TIMER = setInterval(() => {
      //   this.getInfo();
      // }, 1000 * 2);
    },
    changeCueeency(index,symbol,bzType) {
      this.bzType = bzType;
      if(this.bzType != 1){
        localStorage.setItem('type',3)
        this.$router.push({ path: '/contractTransaction', query: { symbol: symbol,selfType : 3 } })
      }
      if(typeof(index) != 'number')index = 0;
      if(this.sellAndBuy.currency==this.marketList[index].name)return
      this.createTimer();
      this.sellAndBuy.currency = this.marketList[index].name;
      this.sellAndBuy.desc = this.marketList[index].desc;
      this.sellAndBuy.price = "";
      this.symbol = this.marketList[index].symbol;
      localStorage.setItem('symbol', this.symbol);
      localStorage.removeItem('klineData');
      localStorage.removeItem('new_price');
      this.dealOrderList.length = 0;
      this.widget.remove();
      this.createWidget();
      this.getCurPrice();
      this.getWeiTuo();
      this.getInfo();
      this.getCurrencyMessage()
    },
    changePrice(price) {
      this.setPrice = price;
    },
    getWeiTuo() {
      if (!this.$store.state.token) return;
      let type = this.type == 3 ? 2 : this.type;
      var data = {
        page: this.page,
        currency: this.sellAndBuy.currency,
        mark: this.tabListLEntrustIndex + 1,
        wt: this.tabListLTitleIndex,
        type: type
      };
      getWeiTuo(data).then(res => {
        if(res.list.length > 0){
          this.weituoList = res.list;
          this.total = res.total;
        }else{
          this.weituoList = res.list;
          this.total = res.total;
          clearInterval(TIMER)
        }

      });
    },
    cancel(index, id) {
      orderCancel({ id }).then(() => {
        if (this.weituoList[index].id == id) {
          this.weituoList[index].status = 2;
        }
      });
    },
    createOrder(data) {
      var token = this.$store.state.token;
      if (!token) {
        this.$message({
          type: "error",
          message: this.$t('text.login')
        });
        return;
      }
      data.deal_type = this.type;
      // if(data.price == '' || data.price == null || data.price <= 0){
      //   this.$message({
      //       type: "",
      //       message: this.$t('deal.qsrsl')
      //     });
      //     return
      // }
      if(data.amount == '' || data.amount == null || data.amount <= 0){
        if(this.type == 1){
          this.$message({
            type: "",
            message: this.$t('deal.qsrsl')
          });
          return
        }else{
          this.$message({
            type: "",
            message: this.$t('deal.qsrss')
          });
          return
        }
      }
      createOrder(data).then(res => {
        this.$message({
          type: "",
          message: this.$t('statusText')[2]
        });
        data.amount = '';
        data.percentVal = 0;
        this.getInfo();
      });
    },
    // "限价交易", "市价交易"
    tabr(index) {
      this.tabListLEntrustIndex = index;
      this.mark = index + 1;
      this.getWeiTuo()
    },
    // "当前委托", "历史委托"
    tabl(index) {
      this.tabListLTitleIndex = index;
      this.getWeiTuo();
    },
    // "买入", "卖出"
    tabe(index) {
      this.tabListLEntrustIndex = index;
      this.getWeiTuo();
    },
    pagechange(page) {
      this.page = page;
      this.getWeiTuo();
    },
    ffff(v = 0, l = 8) {
      l = 4;
      return parseFloat(v).toFixed(l);
    },
    setValue(obj) {
      //交易对、币种、当前价格、人民币价格、最高价、最低价、涨幅、24小时成交量
      /*
      "symbol",
      "currency_name",
      "now_price",
      "now_price",
      "high",
      "low",
      "change",
      "volume"
      */
      if(typeof(obj)!='object')return;
      if (obj.symbol == this.symbol) {
        this.sellAndBuy.symbol = obj.symbol;
        this.sellAndBuy.currency = obj.currency_name;
        var o = this.getMarketInfo(this.symbol)
        if(o){
          obj.now_price = number_round(marke_price(obj.now_price,o.is_control,o.buy_control_value,o.risk_value))
        }
        this.sellAndBuy.price = obj.now_price;
        localStorage.setItem('new_price',obj.now_price)

        this.sellAndBuy.cny = obj.now_price;
        this.sellAndBuy.high = number_round(obj.high);
        this.sellAndBuy.low = number_round(obj.low);
        this.sellAndBuy.ins = number_round(obj.change,window.GLOBAL.NUMBER_ROUND_2);
        this.sellAndBuy.sum = number_round(obj.volume);
      }
      this.marketList.forEach(o => {
        if (o.symbol == obj.symbol) {
          o.grow = number_round(obj.change, window.GLOBAL.NUMBER_ROUND_2)
          o.now_price = number_round(marke_price(obj.now_price, o.is_control,o.buy_control_value,o.risk_value))
        }
      })
    },
    checkToken(){
      var token = this.$store.state.token;
      if (!token) {
        this.$message({
          type: "error",
          message: this.text_login
        })
        return 1
      }
      return 0
    },
    path(path) {
      if (this.checkToken()) return
      localStorage.setItem("type", this.type);
      localStorage.setItem("web-currency", this.sellAndBuy.currency);
      this.$router.push({ path: path })
    },
    setDeal(obj) {
      if(typeof(obj)!=='object' || this.symbol!=obj.symbol)return;

      var asks = obj.asks; // 卖
      var bids = obj.bids; // 买

      var buy = [];
      asks.forEach((o,i) => {
        buy.push({
          title: this.deal_dir[1]+(asks.length-i),
          price: number_round(o[0]),
          number: number_round(o[1])
        });
      })
      var sell = [];
      bids.forEach((o,i) => {
        sell.push({
          title: this.deal_dir[0]+(i+1),
          price: number_round(o[0]),
          number: number_round(o[1])
        });
      })
      this.sellAndBuy.buy = sell;
      this.sellAndBuy.sell = buy;
      if(this.isScroll){
        this.isScroll = false
        this.scrollTop()
      }
    },
    getInfo() {
      // if (!this.$store.state.token) return;
      let type;
      if(this.type == 3){
        type = 2
      }else{
        type = this.type;
      }
      var data = {
        currency: this.sellAndBuy.currency,
        type: type
      };
      if (!data.currency) return;
      getInfo(data).then(res => {
        res.wallet.lot = res.lot;
        res.wallet.max_cnt = res.max_cnt;
        this.wallet = res.wallet;
        this.deal_rate = res.deal_rate;
        this.lot = res.lot;
        this.usdt = res.usdt;
        this.k_line_txt[1] = res.unit;
      });
    },
    getNewData(){
      let params = {
        symbol: this.symbol.split('/')[0]+'usdt'
      };
      new_data(params).then(msg => {
         if (typeof msg === "string") msg = JSON.parse(msg);
         if (msg.daymarket) {
            this.setValue(JSON.parse(msg.daymarket));
          }
          if (msg.market_depth) {
            this.setDeal(JSON.parse(msg.market_depth));
          }
          if (msg.match_trade) {
            var data = JSON.parse(msg.match_trade).data;
            data.forEach(obj => {
              if (this.dealOrderList.length === this.match_trade_len) {
                this.dealOrderList.pop();
              }
              this.dealOrderList.unshift({
                class: obj.direction,
                time: this.timestampToTime(obj.ts),
                price: number_round(obj.price),
                sum: number_round(obj.amount)
              });
            });
          }
      })
    },
    buy(obj,fx){
      this.getCutTimeList();
      this.getInfo();
      this.timeIdx = 0;
      this.isMask = true;
      this.isJgShow = true;
      this.fxText = obj;
      this.fx = fx;
      clearInterval(this.timerTimes);
      this.timerTimes = null;
    },
    getCutTimeList(){
      cutTimeList({currency:this.symbol.split('/')[0]}).then(res => {
        this.cutTimeList = res.list;
        this.timeObj = res.list[this.timeIdx];
        this.rate = res.rate;
      })
    },
    timeSelect(idx,obj){
      this.timeIdx = idx;
      this.timeObj = obj;
      this.tzmoney = '';
    },
    order(){//下单
        let that = this;
        clearInterval(that.timerTimes);
        that.timerTimes = null;
        clearInterval(that.orderTimes);
        that.orderTimes = null;
        $('#times').html('');
        that.detailData = {};
        let params = {
            currency: this.symbol.split('/')[0],
            amount: this.tzmoney,
            type: this.fx,
            timeid: this.timeObj.id
        }
        if(this.tzmoney == '' || this.tzmoney == null){
          this.$message({
            type: "error",
            message: this.$t('deal.qsrsl')
          });
          return;
        }else if(parseFloat(this.tzmoney) <= 0){
          this.$message({
            type: "error",
            message: this.$t('deal.qsrsl')
          });
          return;
        }else if(parseFloat(this.tzmoney) < parseFloat(that.timeObj.amount_min)){
            this.$message({
              type: "error",
              message: this.$t('jgcc.zxje') + that.timeObj.amount_min
            });
            return;
        }else if(parseFloat(this.tzmoney) > parseFloat(that.timeObj.amount_max)){
            this.$message({
              type: "error",
              message: this.$t('jgcc.zdje') + that.timeObj.amount_max
            });
            return;
        }else if(parseFloat(this.tzmoney) > parseFloat(this.wallet.usdt)){
            this.$message({
              type: "error",
              message: this.$t('jgcc.yebz')
            });
            return;
        }
        if(that.count == 1){
          that.count = 0;
          $('#order').css('background','#666')
        }else{
          $('#order').css('background','#666')
          return false;
        }
        cutBuy(params).then((res) => {
            that.orderId = res;
            this.$message({
              type: "",
              message: this.$t('statusText')[2]
            });
            that.isJgShow = false;
            that.isJgTime = true;
            that.is_close = false;
            that.tzmoney = '';
            that.getOrderDetail();
            that.getInfo();
            setTimeout(()=>{
                that.count = 1;
                $('#order').css('background','#4bb3e8');
            },2000)
        });
    },
    getOrderDetail(){
      let that = this;
      $('#times').html('');
      clearInterval(this.timerTimes);
      this.timerTimes = null;
      cutOrder({id:that.orderId}).then((res) => {
        that.detailData = res;
        if(that.is_close){
            if(res.is_close != 1){
                that.orderTimes = setInterval(() => {
                    that.getOrderDetail();
                },1000);
            }
            return false;
        }
        that.downTimes(that.cutTimeList[that.timeIdx].time)
      });
    },
    downTimes(cutTime){
        var that = this;
        var t = cutTime;
        var n = document.getElementById("circle");
        var totalTimes = parseInt(Date.now() / 1000) + cutTime;
        $('#times').html( t + ' ' + 'S');
        if(that.is_close){
            clearInterval(that.timerTimes);
            that.timerTimes = null;
            clearInterval(that.orderTimes);
            that.orderTimes = null;
            return false;
        }else{
            var ddz = that.$t('jgcc.ddz');
            that.timerTimes = setInterval(()=> {
               var that = this;
                t = parseInt(totalTimes - parseInt(Date.now() / 1000));
                if (t <= 0){
                    that.is_close = true;
                    $('#times').html('');
                    setTimeout(()=>{
                        that.getOrderDetail()
                    },2000);
                    clearInterval(that.timerTimes);
                    that.timerTimes = null;
                }else {
                    // t -= 1;
                    $('#times').html( t + ' ' + 'S');
                    let e = Math.floor(t / cutTime * 230);
                    n.style.strokeDashoffset = e - 230;
                }
            },1000);
        }
    },
    agin(){
        this.isMask = true;
        this.isJgTime = false;
        this.isJgShow = true;
        this.is_close = false;
        this.tzmoney = '';
        this.count = 1;
        $('#order').css('background','#4bb3e8');
        this.getCutTimeList();
        this.getInfo();
        clearInterval(this.timerTimes);
        this.timerTimes = null;
        $('#times').html('');
        clearInterval(this.orderTimes);
        this.orderTimes = null;
        document.getElementById("circle").style.strokeDashoffset = 0;
    },
    close(){
        this.isJgShow = false;
        this.isJgTime = false;
        this.isMask = false;
        this.is_close = false;
        this.tzmoney = '';
        this.count = 1;
        $('#order').css('background','#4bb3e8');
        clearInterval(this.timerTimes);
        this.timerTimes = null;
        $('#times').html('');
        clearInterval(this.orderTimes);
        this.orderTimes = null;
        document.getElementById("circle").style.strokeDashoffset = 0;
    },
    keyMoney(){
      var amount =  this.tzmoney;
      amount = amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
      amount = amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      amount = amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
      amount = amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
      if (amount.indexOf(".") < 0 && amount != "") { //首位是0的话去掉
        amount = parseFloat(amount)
      }
      this.tzmoney = amount;
    },
    // socket() {
    //   __socket.emit("login", "login");

    //   if(window.GLOBAL.is_sw_market){
    //       this.socket_daymarket();
    //   }

    //   this.socket_market_depth();
    //   this.socket_match_trade();
    // },
    // 最新价
    socket_daymarket() {
      __socket.on("daymarket", msg => {
        if (typeof msg === "string") msg = JSON.parse(msg);
        if (msg.type == "daymarket") {
          this.setValue(msg);
        }
      });
    },
    // 买10 卖10
    socket_market_depth() {
      __socket.on("market_depth", msg => {
        if (typeof msg === "string") msg = JSON.parse(msg);
        if (msg.type == "market_depth" && msg.symbol == this.symbol) {
          this.setDeal(msg);
        }
      });
    },
    socket_match_trade() {
      __socket.on("match_trade", msg => {
        if (typeof msg === "string") msg = JSON.parse(msg);
        if (msg.type == "match_trade" && msg.symbol == this.symbol) {
          var data = msg.data;
          data.forEach(obj => {
            if (this.dealOrderList.length === this.match_trade_len) {
              this.dealOrderList.pop();
            }
            //console.log(this.timestampToTime(obj.ts))
            this.dealOrderList.unshift({
              class: obj.direction,
              time: this.timestampToTime(obj.ts),
              price: number_round(obj.price),
              sum: number_round(obj.amount)
            });
          });
        }
      });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var h = date.getHours()<10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return h + m + s;
    }
  },
  filters: {
    fx(val){
        if(val == 1){
            return that.$t('jgcc.mz')
        }else if(val == 2){
            return that.$t('jgcc.md')
        }else{
            return that.$t('jgcc.mz')
        }
    },
    toFixed4: function (value, options) {
        value = Number(value);
        return value.toFixed(4);
    },
    times: function (value, options) {
        if(value){
            if(value.indexOf(that.miao) > 0){
                return value
            }else{
                return ''
            }
        }else{
            return ''
        }
    },
    priceType(val){
      if(val == 0){
          return that.$t('deal.tabListRTitle[0]')
      }else{
          return that.$t('deal.tabListRTitle[1]')
      }
    }
  },
};
</script>

<style lang="scss">
// 弹出框北京颜色
$background-popup-color:#1c283e;
// 弹出框右列背景色
$background-popup-list-color:#141d2d;
//中间个人信息背景色
$background-account-color:#141d2d;
// 委托列表背景色
$background-entrust-color:#1c283e;
// 创建订单框背景色
$background-order-color:#1c283e;
// 创建订单输入框背景色
$background-order-input-color:#0c1929;
// 十档行情每栏背景色
$background-10-color:#141d2d;
// 十档行情中间当前价格栏背景色
$background-10-center-color:#1c283e;
// 最新交易背景色
$background-deal-color:#0c1929;

$green:#4db872;
$red:#ee6560;


.deal-main {
  height:100vh;
  width:100%;
  overflow: hidden;
  //background: #121d32;
  /*头部 S*/
  .header {
    height: 54px;
    position: relative;
    display: flex;
    background: linear-gradient(90deg,#041636, #061a3d, #081e47,#09224e,#0b2656);
    .back{
      width: 30px;
      height: 30px;
      margin-top: 12px;
      cursor: pointer;
    }
    .logo {
      height: 2rem;
      // width: 9rem;
      margin-left: 1rem;
      margin-top: 0.75rem;
    }
  }
  .choose-type{
    color: #fff;
    line-height: 54px;
    margin-left: 26px;
    cursor: pointer;
    font-size: .875rem;
    position: relative;
    label,span{
      font-size:.875rem;
    }
    &.choose-min{
      min-width: 86px;
    }

    .iconfont{
      font-size: .675rem;
      color:#aaa;
    }
    .icon-xiangxiajiantoushixin{
      display:inline-block;
    }
    .icon-xiangshang{
      display:none;
    }
    .b{
      color: #e2a028;
      font-size: .475rem;
      border: 1px solid #e2a028;
      border-radius: 4px;
    }
  }
  .choose-type:hover{
    .icon-xiangshang{
      display:inline-block;
    }
    .icon-xiangxiajiantoushixin{
      display:none;
    }
    .choose-list{
      display: block;
    }
  }
  .choose-list{
    width:120px;
    background: $background-popup-color;
    position: absolute;
    display: none;
    top: 54px;
    z-index:999;
  }
  .choose-list>div{
    line-height: 30px;
    text-align: center;
    font-size: .875rem;
    color:#fefefe;
    &.active{
      color:#2558d9;
    }
  }
  .choose-list>div.a:hover{
    background: #1c3051;
  }
  .choose-currency{
    .choose-list{
      width: 360px;
    }
    .search{
      height:36px;
      background: $background-popup-color;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        margin-left:16px;
      }
      input{
        margin-left:16px;
        flex:1;
        color:#eee;
      }
    }
    .content{
      background:$background-popup-color;
      display: flex;
      .sc{
        width:116px;

        display: flex;
        flex-direction: column;
        label{
          color:#fefefe;
          cursor: pointer;
          font-size:.875rem;
          &:first-child{
            color:#999;
          }
          &.active{
            color:#2558d9;
            border-left:4px solid #2558d9;
          }
        }
      }
      .bz{
        flex: 1;
        background: $background-popup-list-color;
      }
      .scoll{
        height: 360px;
        overflow-y: scroll;
      }
      .th{
        background: $background-popup-color;
      }
      .th,.tr{
        display: flex;
      }
      .th .td,.tr .td{
        width:40%;
        text-align: right;
        margin-right:8px;
        font-size: .675rem;
      }
      .th .td span,.tr .td span{
        font-size: .675rem;
      }
      .th .td:first-child{
        margin-left: 36px;
      }
      .tr .td:first-child{
        margin-left: 10px;
      }
      .tr .td:first-child span{
        margin-left: 4px;
      }
      .th .td{
        color: #999;
        font-size: .875rem;
      }
      .th .td:first-child,
      .tr .td:first-child{
        text-align: left;
        width:60%;
      }
    }
  }
  .choose-about{
    .choose-list{
      width:400px;
      padding: 5px 10px;
      left: -40px;
    }
    .form{
      display: flex;
      flex-direction: column;
    }
    .form-2{
      flex-direction: row;
      .form-item{
        flex-direction: column;
        padding:8px;
        .title,.detail{
          text-align: center;
        }
      }
    }
    .form-group{
      display: flex;
      flex-direction: row;
      &>.form-item{
        width:50%;
      }
    }
    .form-item{
      display: flex;
      justify-content: flex-start;
      .title{
        display: inline-block;
        width: 88px;
        text-align: left;
        font-size:.875rem;
        color:#aaa;
      }
      .detail{
        color: #fefefe;
        flex: 1;
        font-size: .675rem;
        word-break: break-word;
        text-align: left;
        &.message{
          max-height: 29rem;
          overflow-y: scroll;
        }
        a{
          color: #fff;
        }
      }
    }
  }
  .form-2{
    display: flex;
    .form-item{
      display: flex;
      flex-direction: column;
    }
  }
  .choose-price::before{
    content: "";
    width: 0;
    height: 28px;
    border: 1px solid rgba(238, 238, 238, 0.2);
    position: absolute;
    top: 12px;
    left: -14px;
  }
  /*头部 E*/

  .flex {
    display: flex;
  }

  /* 内容 S */
  .deal-content {
    display: flex;
    justify-content: space-between;
    min-width: 1280px;
    width: 100%;
    height:calc(100vh - 62px);
  }
  .right {
    position: relative;
    width: 539px;
    height:100%;
  }
  .right .tab-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    color: #637085;
    font-size: 12px;
  }
  .left {
    // width: calc(100% - 542px);
    width: calc(100% - 543px);
    height:100%;
  }
  .left-t {
    height: calc(100% - 266px);
    display: flex;
  }
  .left-box-1 {
    width: 260px;
    box-sizing: border-box;
    padding: 15px 0;
    background: #121d32;
    margin-right: 3px;
  }
  .left-box-2 {
    min-width: 510px;
    // width: calc(100% - 260px);
    width: 100%;
    background: #121d32;
  }
  // 左边货币
  .currency {
    .currency-title {
      text-align: center;
      margin-right: 25px;
      color: #7a98f7;
      border-bottom: 1px solid #7a98f7;
      display: inline-block;
      cursor: pointer;
      margin-left: 25px;
    }
    .th {
      .td {
        height: 36px;
        line-height: 36px;
        text-align: center;
        float: left;
        color: #637085;
        font-size: 12px;
      }
    }
    .line {
      width: 90%;
      margin: 0 auto;
      border-bottom: 1px solid #2e3753;
    }
    .tr {
      .td {
        line-height: 30px;
        cursor: pointer;
        font-size: 12px;
        color: #cdd6e4;
        text-align: center;
        &.up {
          color: $green;
        }
        &.down {
          color: $red;
        }
      }
      &:hover {
        background-color: rgba(46, 55, 83, 0.4);
      }
    }
    .td {
      flex: 1;
    }
  }
  // 左边K线图
  .k-line {
    .top {
      height: 50px;
      width: 100%;
      padding: 0 10px;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      background: #1a243b;
      border-bottom: 2px solid #000;
      div {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        margin-left: 15px;
        span {
          font-size: 12px;
          color: #b0b8db;
          &.green {
            font-size: 14px;
            &.fs12 {
              font-size: 12px;
            }
          }
        }
        &.unit {
          font-size: 18px;
          color: #d2d6ec;
        }
      }
    }
    .trading-view {
      // width: 100%;
      // height: 535px;
    }
  }
  // left b
  .left-b {
    margin-top: 4px;
    padding: 0 15px;
    background: $background-entrust-color;
    // height: 385px;
    //height:calc(100% - 304px);
    height:220px;
    min-width: 560px;
    .tab {
      color: hsla(0, 0%, 100%, 0.8);
      font-size: 14px;
      line-height: 1.6;
      height: 30px;
      display: flex;
      justify-content: space-between;
      .tab-item {
        margin-right: 14px;
        line-height: 30px;
        cursor: pointer;
        font-size:14px;
        &.active {
          color: #7a98f7;
          border-bottom: 1px solid #7a98f7;
        }
      }
    }
    .entrust-content .wtgd-box{
      display: flex;
      align-items: stretch;
    }
    .entrust-content .wtgd-box .wtgd-left{
      width: 50%;
    }
    .entrust-content .wtgd-box .wtgd-right{
      width: 50%;
    }
    .entrust-content .cont {
      padding: 12px 0;
      color: #fff;
      font-size: 12px;
    }
    .entrust-content .cont-ul .cont-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 10px;
    }
    .entrust-content .cont-ul .cont-li .text{
      color: #fff;
      font-size: 12px;
    }
    .entrust-tab {
      display: flex;
      line-height: 46px;
      height: 46px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
      .entrust-tab-item {
        margin-right: 40px;
        cursor: pointer;
        span {
          color: #c7cce6;
          font-size: 12px;
        }
        &.active {
          span {
            color: #7a98f7;
            border-bottom: 1px solid #7a98f7;
          }
        }
      }
    }
    .entrust-content {
      .th {
        line-height:  28px;
        border-bottom: 1px solid #303b4b;
        height: 28px;
        width: 100%;
        .td {
          font-size: 12px;
          color: #637085;
        }
      }
      .tr {
        align-items: center;
        // line-height: 28px;
        border-bottom: 1px solid #303b4b;
        // height: 28px;
        width: 100%;
        padding: 8px 0;
        .td {
          font-size: 12px;
          color: #c7cce6;
        }
      }
      .td {
        width: 12.5%;
        text-align: center;
        flex-shrink: 0;
        span {
          font-size: 12px;
          &.btn {
            color: #7a98f7;
            cursor: pointer;
          }
        }
      }
      .td-2 {
        width: 25%;
        &.mr{
          color: #00c483;
        }
        &.mc{
        color: #d14b65;
       }
      }
      .td-3 {
        width: 33%;
      }
      .td-6 {
        width: 66%;
        text-align: right;
      }
      .tl{
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .tr{
        text-align: right;
      }
    }
  }
  // 左边结束

  // 右边开始
  .right-t {
    display: flex;
    justify-content: space-between;
    height:100%;
  }
  .right-t-l,
    .right-t-r {
      width: 300px;
      background: $background-10-color;
      color: #c7cce6;
      height: 100%;
    }
    .right-t-r {
      width: 236px;
      background: $background-deal-color;
    }
    .right-t-l,
    .right-t-r {
      .price {
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid $background-10-center-color;
        padding: 0 20px;
        font-size: 14px;
      }
        .td {
          flex: 1;
          font-size: 12px;
          color: #c7cce6;
          text-align: center;
          &.sell {
            color: $red;
          }
          &.buy {
            color: $green;
          }
        }
        .tr {
          line-height: 25px;
          overflow-y: auto;
          overflow-x: hidden;
          cursor: pointer;
          &:hover {
            background: rgba(46, 55, 83, 0.4);
          }
        }
        .th {
          line-height: 25px;
          position: relative;
          color: #637085;
          font-size: 12px;
          text-align: center;
          .td {
            color: #637085;
          }
        }
        .line {
          display: flex;
          padding: 0 30px;
          color: #b0b8db;
          background: #1c2831;
          line-height: 28px;
          span {
            color: #b0b8db;
            font-size: 12px;
            &:first-child {
              color: $red;
              font-size: 14px;
            }
          }
        }
        .line-back{
          background: #1c2831;
          line-height: 28px;
          display: none;
        }
    }
    .right-t-r {
      .list .tr {
        line-height: 26px;
      }
    }

  // end
  .right-t-l .list{
      position:relative;
      overflow-y: scroll;
      overflow-x: hidden;
      height: calc(100% - 347px);
      .tr{
        background:#141d2d;
        border-top:1px solid #041025;
      }
    }

  .right-b {
    background: $background-order-color;
    height:290px;
    overflow-y: scroll;
    .right-b-tab {
      // box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-around;
      background: $background-order-input-color;
      .right-b-tab-item {
        cursor: pointer;
        color: #aaa;
        width:50%;
        line-height: 30px;
        text-align: center;
        &.active {
          color: $green;
          border-top: 2px solid $green;
          background: $background-order-color;
        }
        &.active1 {
          color: $red;
          border-top: 2px solid $red;
          background: $background-order-color;
        }
      }
    }
    .right-b-content {
      display: flex;
      .right-c-l,
      .right-c-r {
        width: 100%;
        font-size: 14px;
      }
      .right-c-l {
        padding: 0 10px;
      }
      .right-c-r {
        padding: 0 25px 0 15px;
      }
    }
  }
  .el-slider__runway{
    margin:12px 0;
  }
  .el-input__icon{
    line-height: 30px;
  }
  .right-b .btn-box{
    width: 300px;
    padding: 10px;
    text-align: center;
    .btn{
      display: block;
      width: 200px;
      height: 36px;
      margin: 30px auto;
      color: #fff;
      border-radius: 4px;
      border: none;
      cursor: pointer;
      text-align: center;
      &.btn1{
        background: #00c483;
      }
      &.btn2{
        background: #d14b65;
      }
    }
  }
  .account{
    height:42px;
    display:flex;
    align-items: center;
    justify-content: flex-start;
    background: $background-account-color;
    margin-top: 4px;
    &>span{
      font-size:14px;
      margin-left:8px;
      &.blue{
        cursor: pointer;
      }
    }
    &>span:first-child{
      margin-left:16px;
    }
  }
}
 .alert-wrap{
    position: fixed;
    z-index: 1000;
    left: 50%;
    top: 0;
    width: 500px;
    height: 100%;
    margin-left: -250px;
    padding: 0 24px;
    box-sizing: border-box;
  }
  .alert-wrap .alert-box{
      position: relative;
      top: 50%;
      width: 100%;
      padding: 0 10px;
      border-radius: 6px;
      background: #374c7c;
      transform: translateY(-50%);
      box-sizing: border-box;
  }
  .alert-wrap .alert-box .alert-head{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0 10px;
      border-bottom: 1px solid #838da5;
  }
  .alert-wrap .alert-box .alert-head .title{
      color: #fff;
      font-size: 14px;
  }
  .alert-wrap .alert-box .alert-head .btn-close{
      width: 14px;
      height: 14px;
      cursor: pointer;
  }
  .alert-wrap .alert-box .order-head{
      justify-content: center;
      border-bottom: none;
  }
  .alert-wrap .alert-box .alert-head .close{
      position: absolute;
      top: 50%;
      right: 10px;
      width: 14px;
      height: 14px;
      margin-top: -7px;
      cursor: pointer;
  }
  .alert-wrap .alert-box .circle-box{
      position: relative;
      width: 84px;
      height: 84px;
      line-height: 84px;
      margin: 8px auto 14px;
  }
  .alert-wrap .alert-box .circle-box .text{
      color: #4bb3e8;
      font-size: 15px;
      text-align: center;
  }
  .alert-wrap .alert-box .circle{
      position: absolute;
      left: 50%;
      top: 50%;
      width: 84px;
      height: 84px;
      transform: translate(-50%,-50%);
  }
  .alert-sec-circle {
    stroke-dashoffset: 0;
    stroke-dasharray: 720;
    transition: stroke-dashoffset 1s linear
  }
  .alert-wrap .alert-box .price-box{
      padding: 37px 0 46px;
      color: #00c488;
      text-align: center;
  }
  .alert-wrap .alert-box .price-box .num{
      font-size: 20px;
  }
  .alert-wrap .item-box{
      padding: 0 20px;
  }
  .alert-wrap .item-box .item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #c3c3c3;
      padding-bottom: 18px;
  }
  .alert-wrap .item-box .item .t1{
      color: #fff;
  }
  .alert-wrap .item-box .item .t2{
      color: #00c483;
  }
  .alert-wrap .item-box .item .t2.red{
      color: #ee6560!important;
  }
  .alert-wrap .alert-btn-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0 18px;
  }
  .alert-wrap .alert-btn-box .btn{
      height: 34px;
      color: #fff;
      border-radius: 4px;
      text-align: center;
  }
  .alert-wrap .alert-btn-box .btn.close{
      width: 80px;
      margin-right: 10px;
      background: #367d99;
      border: none;
  }
  .alert-wrap .alert-btn-box .btn.order{
      flex: 1;
      background: #4bb3e8;
      border: none;
      cursor: pointer;
  }
  .alert-wrap .alert-tips{
      padding: 10px 0;
      color: #c3c3c3;
  }
  .alert-wrap .time-wrap{
      width: 100%;
      height: 104px;
      overflow: hidden;
  }
  .alert-wrap .time-wrap .time-box{
      width: 100%;
      height: 104px;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
  }
  .alert-wrap .time-wrap .time-box::-webkit-scrollbar{
    width: 10px;
    height: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
  .alert-wrap .time-wrap .time-item{
      position: relative;
      display: inline-block;
      min-width: 94px;
      height: 90px;
      margin-right: 9px;
      font-size: 13px;
      border: 2px solid transparent;
      border-radius: 6px;
      background: #30385d;
      cursor: pointer;
      text-align: center;
  }
  .alert-wrap .time-wrap .time-item.active{
      border: 2px solid #4bb3e8;
  }
  .alert-wrap .time-wrap .time-item .icon{
      position: absolute;
      right: -2px;
      top: -2px;
      width: 28px;
      height: 26px;
  }
  .alert-wrap .time-wrap .time-item .t1{
      padding: 12px 4px 9px;
      color: #8e8e8e;
      font-size: 12px;
  }
  .alert-wrap .time-wrap .time-item .time{
      color: #4bb3e8;
  }
  .alert-wrap .time-wrap .time-item .num{
      font-size: 16px;
  }
  .alert-wrap .time-wrap .time-item .t2{
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 5px 0;
      color: #db4949;
      font-size: 12px;
      border-radius: 0 0 6px 6px;
      background: rgba(0,0,0,.5);
      span{
        font-size: 12px;
      }
  }
  .alert-wrap .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      border-radius: 6px;
      background: #30385d;
  }
  .alert-wrap .input-box .input{
      flex: 1;
      height: 36px;
      padding: 0 9px;
      color: #fff;
  }
  .alert-wrap .input-box .text{
      color: #c3c3c3;
      padding-right: 10px;
  }
  .alert-wrap .ky-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      color: #c3c3c3;
      border-bottom: 1px solid #838da5;
  }
  .alert-wrap .ky-box .text{
    display: flex;
    align-items: center;
  }
  .alert-wrap .ky-box .text .money{
      padding: 0 10px;
  }
  .alert-wrap .ky-box .text .icon{
      width: 20px;
      height: 20px;
      cursor: pointer;
  }
  .alert-wrap .trade-wrap{
      padding: 8px 0 20px;
  }
  .alert-wrap .trade-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  .alert-wrap .trade-box .text{
      width: 33.33%;
      color: #c3c3c3;
  }
  .alert-wrap .trade-box .text-center{
    text-align: center;
  }
  .alert-wrap .trade-box .text-right{
    text-align: right;
  }
  .alert-wrap .trade-item{
      padding-top: 14px;
  }
  .alert-wrap .trade-item .t1{
      color: #fff;
  }
  .alert-wrap .trade-item .t2{
      color: #00c483;
  }
  .alert-wrap .trade-item .t2.active{
      color: #d14b65;
  }
  .alert-wrap .trade-item .t3{
      color: #4bb3e8;
  }
</style>



// WEBPACK FOOTER //
// src/views/deal/main.vue